module.exports = __webpack_public_path__ + "assets/img/baiEditIcon.4745efad.png";